import { render, staticRenderFns } from "./ResultSearchGlobalOrderById.vue?vue&type=template&id=6c7281b6&"
import script from "./ResultSearchGlobalOrderById.vue?vue&type=script&lang=js&"
export * from "./ResultSearchGlobalOrderById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports